import { getCookie } from './cookies';

export const config = {
  baseUrl: import.meta.env.VITE_BASE_URL,
  servicesUrl: import.meta.env.VITE_SERVICES_URL,
  panelUrl: import.meta.env.VITE_PANEL_URL,
  playgroundUrl: import.meta.env.VITE_PLAYGROUND_URL,
  statusPageURL: import.meta.env.VITE_STATUS_PAGE_URL,
  helpCenterURL: import.meta.env.VITE_HELP_CENTER_URL,
  discordUrl: import.meta.env.VITE_DISCORD_URL,
  contactUsUrl: import.meta.env.VITE_CONTACT_US_URL,
  docUrl: import.meta.env.VITE_DOC_URL,
  assistantUrl: import.meta.env.VITE_ASSISTANT_URL,
  baseDomain: import.meta.env.VITE_BASE_DOMAIN,
  paypalClientId: import.meta.env.VITE_PAYPAL_CLIENT_ID,
  paypalSandboxURL: import.meta.env.VITE_PAYPAL_URL,
  feedbackFormURL: import.meta.env.VITE_FEEDBACK_FORM_URL,
  growthbookKey: import.meta.env.VITE_GROWTHBOOK_KEY,
  featuresUpgrade: import.meta.env.VITE_FEATURES_UPGRADE,
  featuresSuggestion: import.meta.env.VITE_FEATURES_SUGGESTION,
  featuresCtaReview: import.meta.env.VITE_FEATURES_CTA_REVIEW,
  featuresCtaYoutubeSeo: import.meta.env.VITE_FEATURES_CTA_YOUTUBE_SEO,
  featuresCtaYoutubeSuggestion: import.meta.env
    .VITE_FEATURES_CTA_YOUTUBE_SUGGESTION,
  TransactionUrl: import.meta.env.VITE_TRANSACTION_URL,
  PaddleToken: import.meta.env.VITE_PADDLE_TOKEN,
  PaddleEnv: import.meta.env.VITE_PADDLE_ENV,
  SentryDSN: import.meta.env.VITE_SENTRY_DSN,
  stateProject: import.meta.env.VITE_STATE_PROJECT,
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,

  token: () => getCookie('token'),
  expires_in: () => localStorage.getItem('expires_Time'),
  lng: () => getCookie('lng', import.meta.env.VITE_BASE_DOMAIN),
  magical_resume_score_data: () => localStorage.getItem('magical-resume-score'),
  resume_score_data: () =>
    getCookie('resume-score', import.meta.env.VITE_BASE_DOMAIN),
  top_keyword: () => getCookie('top-keyword', import.meta.env.VITE_BASE_DOMAIN),
  suggestion: () => getCookie('suggestion', import.meta.env.VITE_BASE_DOMAIN),
  youtubeTitle: () =>
    getCookie('youtube-title', import.meta.env.VITE_BASE_DOMAIN),
  youtubeDescription: () =>
    getCookie('youtubeDescription', import.meta.env.VITE_BASE_DOMAIN),
  youtubeHashtags: () =>
    getCookie('youtubeHashtags', import.meta.env.VITE_BASE_DOMAIN),
  profile_data: () =>
    getCookie('profile-data', import.meta.env.VITE_BASE_DOMAIN),
  resume_parser: () =>
    getCookie('resume-parser', import.meta.env.VITE_BASE_DOMAIN),
  resume_review: () =>
    getCookie('resume-review', import.meta.env.VITE_BASE_DOMAIN),
  company_data: () =>
    getCookie('company-data', import.meta.env.VITE_BASE_DOMAIN),
  youtube_seo: () => getCookie('youtube-seo', import.meta.env.VITE_BASE_DOMAIN),
  open_discord_modal: () => localStorage.getItem('open_discord_modal'),
  close_second_navbar: () => localStorage.getItem('close_second_navbar'),
  finish_stepper: () => localStorage.getItem('finish_stepper'),
  show_upgrade_modal: () => localStorage.getItem('show_upgrade_modal'),
  show_suggestion: () => localStorage.getItem('show-suggestion'),
  first_time_trial: () => localStorage.getItem('first_time_trial'),
};
